let originalThumbnailUrl = '';
let originalImageCaption = '';

let g_devtricker_imageChanged = false;
let g_devtricker_remove_thumbnail = false;
let g_devtricker_thumb_display_position = null;

const saveThumbButton = document.querySelector('#saveThumbButton');
const uploadThumbnailInput = document.getElementById('uploadThumbnail');
const figcaptionTextArea = document.getElementById('thumbnailCaptionInput');
const removeThumbnailButton = document.getElementById('removeThumbnailButton');
const placeholderElement = document.getElementById('thumbnailPlaceholder');
const imageThumbnailPreview = document.getElementById('thumbnailPreview');
const thumbnailContainer = document.querySelector(".thumbnail-container");
const displayImage = document.getElementById("displayImage");
const displayPosition = document.getElementById("displayPosition");
const thumbnailSettingsModal = document.getElementById("thumbnail-settings-modal");

document.addEventListener('DOMContentLoaded', async function () {
    if (saveThumbButton) {
        const path = window.location.pathname;
        const segments = path.split('/');
        const postId = segments[2] || 0;

        originalImageCaption = "";
        figcaptionTextArea.innerHTML = "";

        if (postId != 0) {
            try {
                const result = await devtricker_getPostThumbnail(postId);

                if (result) {
                    imageThumbnailPreview.src = originalThumbnailUrl = result.url;
                    figcaptionTextArea.innerHTML = originalImageCaption = result.caption || "";

                    if (resultHasPosition(result)) {
                        activatePosition(result);
                    }

                    activateImageFields();
                } else {
                    figcaptionTextArea.innerHTML = "";
                }
            } catch (error) {
                console.error('Error fetching thumbnail:', error);
            }
        }
    }
});

if (uploadThumbnailInput) {
    uploadThumbnailInput.addEventListener('change', function (event) {
        try {
            g_devtricker_remove_thumbnail = false;
            g_devtricker_imageChanged = true;

            const file = event.target.files[0];
            if (!file) return;

            if (!file.type.startsWith('image/')) {
                throw new Error("The uploaded file is not an image.");
            }

            const reader = new FileReader();
            reader.onload = function (e) {
                imageThumbnailPreview.src = e.target.result;
            };
            reader.readAsDataURL(file);
            activateImageFields();

            saveThumbButton.removeAttribute("disabled");

        } catch (error) {
            g_devtricker_imageChanged = false;
            devtricker_showThumbnailSettingsModalToast(devtricker_createErrorToast('top', 10, error.message));
            saveThumbButton.setAttribute("disabled", true);
        }
    });
}

if (figcaptionTextArea) {
    figcaptionTextArea.addEventListener('input', function (event) {
        saveThumbButton.removeAttribute("disabled");
    });
}

if (thumbnailSettingsModal) {
    thumbnailSettingsModal.addEventListener('hidden.bs.modal', function (event) {
        g_devtricker_remove_thumbnail = false;
        g_devtricker_imageChanged = false;

        restoreOriginalValues();

        if (hasImage()) {
            activateImageFields();
        } else {
            inactivateImageFields();
        }

        saveThumbButton.setAttribute("disabled", true);
    });
}

function restoreOriginalValues() {
    imageThumbnailPreview.src = originalThumbnailUrl;
    figcaptionTextArea.innerHTML = originalImageCaption;
}

function activateImageFields() {
    placeholderElement.style.display = "none";
    thumbnailContainer.style.display = 'block';
    figcaptionTextArea.setAttribute("contenteditable", true);
    displayImage.removeAttribute("disabled");
    imageThumbnailPreview.style.display = 'block';
}

function resultHasPosition(result) {
    return result.position && result.position !== "";
}

function activatePosition(result) {
    g_devtricker_thumb_display_position = result.position;
    displayImage.checked = true;
    displayPosition.value = result.position;
    displayPosition.removeAttribute("disabled");
}

function inactivateImageFields() {
    placeholderElement.style.display = "flex";
    thumbnailContainer.style.display = 'none';
    displayImage.setAttribute("disabled", true);
    displayPosition.setAttribute("disabled", true);
    figcaptionTextArea.setAttribute("contenteditable", false);

    displayImage.checked = false;
    figcaptionTextArea.innerHTML = "";
    imageThumbnailPreview.src = "";
    uploadThumbnailInput.value = "";
}

if (saveThumbButton) {
    saveThumbButton.addEventListener('click', async function () {
        let interval;
        let loadingOverlay;

        const file = uploadThumbnailInput.files[0];

        const isImageChanged = g_devtricker_imageChanged;

        saveThumbButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving...`;

        const path = window.location.pathname;
        const segments = path.split('/');
        const postId = segments[2] || 0;

        if (postId == 0) {
            await saveChanges();
        }

        try {
            if (isImageChanged && file) {

                const parentContainer = imageThumbnailPreview.parentElement;
                parentContainer.style.position = 'relative';

                loadingOverlay = document.createElement('div');
                loadingOverlay.style.position = 'absolute';
                loadingOverlay.style.top = '0';
                loadingOverlay.style.right = '0';
                loadingOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                loadingOverlay.style.color = '#d3d3d3';
                loadingOverlay.style.padding = '5px';
                loadingOverlay.style.borderBottomLeftRadius = '5px';
                loadingOverlay.style.display = 'flex';
                loadingOverlay.style.alignItems = 'center';
                loadingOverlay.style.zIndex = '10';
                loadingOverlay.style.width = 'auto';

                const spinner = document.createElement('div');
                spinner.classList.add('spinner-border', 'spinner-border-sm');
                spinner.setAttribute('role', 'status');
                spinner.style.marginRight = '5px';

                const percentageText = document.createElement('span');
                percentageText.textContent = '0%';

                loadingOverlay.appendChild(spinner);
                loadingOverlay.appendChild(percentageText);

                parentContainer.appendChild(loadingOverlay);

                let percentage = 0;
                interval = setInterval(() => {
                    percentage += 10;
                    if (percentage >= 100) {
                        percentage = 100;
                        percentageText.textContent = `${percentage}%`;

                        setTimeout(() => {
                            clearInterval(interval);
                            loadingOverlay.remove();
                        }, 200);
                    } else {
                        percentageText.textContent = `${percentage}%`;
                    }
                }, 200);

                const result = await devtricker_uploadPostThumbnail(file, postId);

                originalThumbnailUrl = imageThumbnailPreview.src = result.url;

                originalImageCaption = result.caption || "";

            } else if (g_devtricker_remove_thumbnail) {
                await devtricker_removePostThumbnail(postId);

                originalThumbnailUrl = imageThumbnailPreview.src = "";

                originalImageCaption = "";

            } else {
                const caption = figcaptionTextArea.innerHTML;

                await devtricker_updateThumbnailMetadata(postId, caption, g_devtricker_thumb_display_position);

                originalImageCaption = caption;
            }

            g_devtricker_imageChanged = false;
            g_devtricker_remove_thumbnail = false;

            saveThumbButton.innerHTML = "Save";
            saveThumbButton.setAttribute("disabled", true);
            uploadThumbnailInput.value = "";

            const modalElement = document.getElementById('thumbnail-settings-modal');
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            modalInstance.hide();

            devtricker_contentWrapperToast(devtricker_createSuccessToast("Thumbnail Updated.", 'top', 68));

        } catch (error) {
            if (interval) {
                clearInterval(interval);
            }
            if (loadingOverlay && loadingOverlay.parentElement) {
                loadingOverlay.remove();
            }

            saveThumbButton.innerHTML = "Save";
            devtricker_showThumbnailSettingsModalToast(devtricker_createErrorToast('top', 10, error.message));
            console.error('Failed to upload thumbnail:', error);
        }

    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (saveThumbButton) {
        var container = document.querySelector('.thumbnail-container');

        if (container) {
            var overlay = container.querySelector('.buttons-overlay');
            container.addEventListener('mouseover', function () {
                overlay.style.opacity = '1';
            });

            container.addEventListener('mouseout', function () {
                overlay.style.opacity = '0';
            });
        }
    }
});

if (removeThumbnailButton) {
    removeThumbnailButton.addEventListener("click", function () {
        g_devtricker_remove_thumbnail = true;

        inactivateImageFields();
        saveThumbButton.removeAttribute("disabled");
    });
}

document.addEventListener('paste', function (e) {
    if (saveThumbButton) {
        const modalElement = document.getElementById('thumbnail-settings-modal');

        if (modalElement.style.display !== 'none' && modalElement.classList.contains('show')) {
            e.preventDefault();
            saveThumbButton.removeAttribute("disabled");

            const pasteData = (e.clipboardData || window.clipboardData);
            const plainTextData = pasteData.getData('text/plain');

            figcaptionTextArea.textContent = plainTextData;
        }
    }
});

if (displayImage) {
    displayImage.addEventListener('change', function () {
        toggleSelectActivation();
        updateGlobalPosition();
        displayPosition.disabled = !this.checked;
    });
}

if (displayPosition) {
    displayPosition.addEventListener('change', updateGlobalPosition);
}

function toggleSelectActivation() {
    saveThumbButton.removeAttribute("disabled");

    if (displayImage.checked) {
        displayPosition.removeAttribute('disabled');
    } else {
        displayPosition.setAttribute('disabled', true);
    }
}

function updateGlobalPosition() {
    if (displayImage.checked) {
        g_devtricker_thumb_display_position = displayPosition.value;
        saveThumbButton.removeAttribute("disabled");
    } else {
        g_devtricker_thumb_display_position = undefined;
    }
}

function devtricker_showThumbnailSettingsModalToast(toastElement) {
    const offcanvasBody = document.querySelector('#thumbnail-settings-modal');

    if (offcanvasBody) {
        offcanvasBody.appendChild(toastElement);

        const toast = new bootstrap.Toast(toastElement);
        toast.show();

        setTimeout(() => {
            toastElement.remove();
        }, 2000);
    }
}

function hasImage() {
    return originalThumbnailUrl != ""
        && originalThumbnailUrl != undefined
        && originalThumbnailUrl != null;
}